export const sortArrayByKeyAsc = (arr: any[], key: string): any[] => {
  return arr.sort((a, b) => a[key] - b[key]);
};

export const sortArrayByDateAsc = (arr: any[], key: string): any[] => {
  return [...arr].sort(
    (a, b) => new Date(a[key]).getTime() - new Date(b[key]).getTime(),
  );
};
